/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LienDetails
 */
export interface LienDetails {
}

/**
 * Check if a given object implements the LienDetails interface.
 */
export function instanceOfLienDetails(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LienDetailsFromJSON(json: any): LienDetails {
    return LienDetailsFromJSONTyped(json, false);
}

export function LienDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): LienDetails {
    return json;
}

export function LienDetailsToJSON(value?: LienDetails | null): any {
    return value;
}

